import React from "react";
import BaseComponent from "../BaseComponent.js";
import styled from "styled-components";
import nota from "../Global/nota.guidelines.json";
import { elementMatchesAny } from "../Global/tools.js";
import Type from "../Global/Typography.js";
import NanoFlex from "../Global/NanoFlex.js";
import Dropdown from "../Nano/Dropdown.js";
import Input from "../Nano/Input.js";
import { Popper, Reference, Manager } from "react-popper";

import { ReactComponent as ArrowUp } from "./../Global/Icons/arrowUp.svg";
import { ReactComponent as ArrowDown } from "./../Global/Icons/arrowDown.svg";
import { ReactComponent as Check } from "./../Global/Icons/check.svg";
import { ReactComponent as Delete } from "./../Global/Icons/delete.svg";
import { ReactComponent as SearchIcon } from "./../Global/Icons/search.svg";

const multiple = nota.global.multiple;
const mainWidth = multiple * 25; /* 200px */
const StyledBlockBox = styled.div`
  width: 100%;
  height: ${multiple * 4 + "px"}; /* 32px */
  padding: ${multiple + "px"}; /* 8px */
  -webkit-user-select: none; /* Chrome all / Safari all */
  -moz-user-select: none; /* Firefox all */
  -ms-user-select: none; /* IE 10+ */
  user-select: none; /* Likely future */
  .dropDownLine {
    svg {
      width: 15px;
      height: 10px;
      path {
        fill: ${(props) => (props.selected ? nota.color.main.default : nota.color.neutral.NeuThree)};
      }
    }
    p {
      margin-left: ${multiple + "px"}; /* 8px */
      font-weight: ${(props) => (props.selected ? `bold` : `normal`)};
      width: 100%;
      /* overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap; */
      display: -webkit-box;
      -webkit-line-clamp: 1;
      -webkit-box-orient: vertical;
      overflow: hidden;
    }
    .deleteIcon {
      width: 25px;
      padding: 16px 0px;
      svg {
        height: 12px;
      }
      &:hover {
        svg {
          path {
            fill: ${nota.color.main.mTwo};
          }
        }
      }
    }
  }
  &:first-child {
    background-color: ${nota.color.neutral.NeuFour};
  }
  &:hover {
    background-color: ${nota.color.neutral.NeuFour};
  }
`;

const BlockBox = (props) => (
  <StyledBlockBox
    onClick={(e) => {
      /*Prevent Click on Delete Icon*/
      if (elementMatchesAny(e.target, [".deleteIcon"])) return;
      return props.blockBoxAction(props.index);
    }}
    selected={props.selected}>
    {props.content && (
      <NanoFlex className="dropDownLine" justifyContent={"flex-start"}>
        <Check />
        {props.customContent && props.customContent()}
        {!props.customContent && <Type.p>{props.content}</Type.p>}
        {props.delete && (
          <NanoFlex className="deleteIcon" onClick={() => props.deleteAction()}>
            <Delete />
          </NanoFlex>
        )}
      </NanoFlex>
    )}
  </StyledBlockBox>
);

const StyledMultipleSelectionDropdown = styled.div`
  width: ${multiple * 29 + "px"};
  border: 1px solid ${nota.color.neutral.NeuTwo};
  font-size: 12px;
  color: ${nota.color.neutral.NeuOne};
  cursor: pointer;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
  -webkit-tap-highlight-color: transparent;
  .dropDownWrapper {
    width: 100%;
    position: relative;
    top: 0;
    left: 0;
    .inputDropDownWrapper {
      width: 100%;
      min-width: ${mainWidth + "px"};
      height: ${multiple * 4 + "px"}; /* 32px */
      .infoDropDownWrapper {
        width: calc(100% - 18px);
        padding: 0 10px;
        p {
          color: ${(props) => (props.displayString ? nota.color.neutral.NeuOne : nota.color.neutral.NeuTwo)};
          width: 100%;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
      }
      .iconDropDownWrapper {
        background-color: ${(props) => (props.indicator ? nota.color.main.mOne : nota.color.main.default)};
        width: 18px;
        padding: 5px;
        svg {
          height: 15px;
          width: 15px;
        }
        .svgMargin {
          margin-top: 2px;
        }
      }
    }
    /* .dropdown-content {
      margin: 0;
      border: 1px solid ${nota.color.neutral.NeuTwo};
      width: calc(100% + 2px);
      min-height: auto;
      max-height: 350px;
      overflow: auto;
    } */
  }

  .inputSearchWrapper {
    position: relative;
    min-height: -webkit-fit-content;
    div {
      margin: 0;
      width: 100%;
      input {
        border: 0;
        border-bottom: 1px solid ${nota.color.neutral.NeuTwo};
        padding: ${multiple + "px"};
        padding-right: 40px;
      }
    }
    .searchIconWrapper {
      position: absolute;
      height: auto;
      right: ${multiple + "px"};
      width: ${multiple * 3 + "px"};
      svg {
        width: 14px;
        height: 14px;
        path {
          fill: ${nota.color.neutral.NeuTwo};
        }
      }
    }
  }
  .noResults {
    padding: ${multiple + "px"};
  }

  .dropDownContentWrapper {
    margin: 0;
    border: 1px solid ${nota.color.neutral.NeuTwo};
    width: calc(100% + 2px);
    height: auto;
    max-height: 350px;
    overflow: auto;
    background: ${nota.color.neutral.white};
    z-index: 1;
  }
`;

class MultipleSelectionDropdown extends BaseComponent {
  constructor(props) {
    super(props);
    let selectedIds = this.props.selected ? this.props.selected : [];
    let options = this.props.options ? this.props.options : [];
    this.state = {
      term: "",
      options: options,
      selectedIds: selectedIds,
      isOpenDropdown: false,
    };

    this.nodeRef = React.createRef();
  }

  componentDidMount() {
    super.componentDidMount();
    document.addEventListener("mousedown", this.handleOutsideClick);
    /*Prevent different IsAllSelected States from Props to State */
    this.validateIsAllSelectedProp();
  }

  componentDidUpdate(prevProps, prevState) {
    if (JSON.stringify(this.state.selectedIds.sort()) !== JSON.stringify(prevState.selectedIds.sort())) {
      this.triggerOnChangeSelection();
    }
    if (JSON.stringify(prevProps.selected) !== JSON.stringify(this.props.selected) || this.props.forceSelection) {
      this.setState({ selectedIds: this.props.selected ? this.props.selected : [], term: this.state.isOpenDropdown ? this.state.term : "" });
      this.validateIsAllSelectedProp();
    }
    if (JSON.stringify(prevProps.options) !== JSON.stringify(this.props.options)) {
      let selectedIds = this.props.options
        .filter((v) => {
          return this.state.selectedIds.includes(v.id);
        })
        .map((v) => {
          return v.id;
        });

      this.setState({ options: this.props.options, selectedIds: selectedIds });
    }
  }

  componentWillUnmount() {
    super.componentWillUnmount();
    document.removeEventListener("mousedown", this.handleOutsideClick);
  }

  handleOutsideClick = (e) => {
    if (!this.nodeRef.current.contains(e.target)) this.setState({ isOpenDropdown: false });
  };

  validateIsAllSelectedProp = () => {
    if (this.props.isAllSelected === true) {
      this.setState({
        selectedIds: this.state.options.map((v) => {
          return v.id;
        }),
      });
    }
  };

  triggerOnChangeSelection = () => {
    if (this.props.onChangeSelection) {
      this.props.onChangeSelection({
        isAllSelected: this.isAllSelected(this.state.options),
        selected: this.state.options.filter((v) => {
          return this.state.selectedIds.includes(v.id);
        }),
      });
    }
  };

  onOptionClick = (v) => {
    if (this.state.selectedIds.includes(v)) {
      this.setState({
        selectedIds: this.state.selectedIds.filter((id) => {
          return id !== v;
        }),
      });
    } else {
      this.setState({ selectedIds: [...this.state.selectedIds, ...[v]] });
    }
  };

  onSelectAllClick = () => {
    /*Get Filtered Results and ids */
    let results = this.getFilteredResults();
    let resultsIds = results.map((v) => v.id);
    /*Validate if is All Selected */
    if (this.isAllSelected(results)) {
      /*Get Ids Excluding current filtered results ids */
      let excludedSelectedIds = this.state.selectedIds.filter((v) => {
        return resultsIds.includes(v) == false;
      });
      this.setState({ selectedIds: excludedSelectedIds });
    } else {
      /*Merge filtered results ids and state selected ids and Distinct */
      let selectedIds = [...new Set([...resultsIds, ...this.state.selectedIds])];
      this.setState({
        selectedIds: selectedIds,
      });
    }
  };

  onTermChange = (value) => {
    this.setState({ term: value });
  };

  getDisplayString = () => {
    /*Add Custom Display String*/
    if (this.props.customDisplayString) {
      var event = {
        handled: false,
        selectedIds: [...this.state.selectedIds],
        displayString: null,
      };
      this.props.customDisplayString(event);
      if (event.handled) return event.displayString;
    }
    if (this.state.selectedIds.length === 0) return "";
    if (this.state.selectedIds.length === this.props.options.length) return this.translation.geral.allSelected;
    let selectedJoin = this.state.options
      .filter((v) => {
        return this.state.selectedIds.includes(v.id);
      })
      .map((v) => {
        return v.name;
      })
      .join(", ");
    if (selectedJoin.length <= 30) return selectedJoin;
    return `${this.state.selectedIds.length} Selected`;
  };

  getFilteredResults = () => {
    if (this.state.term.trim() !== "") {
      let upperTerm = this.state.term.trim().toUpperCase();
      return this.state.options.filter((v) => {
        let upperName = v.name.trim().toUpperCase();
        return upperName.includes(upperTerm);
      });
    } else {
      return this.state.options;
    }
  };

  isAllSelected = (results) => {
    let resultsIds = results.map((v) => v.id);
    let filteredSelectedIds = this.state.selectedIds.filter((v) => {
      return resultsIds.includes(v);
    });
    return filteredSelectedIds.length === results.length;
  };

  render() {
    let displayString = this.getDisplayString();
    let filteredResults = this.getFilteredResults();
    return (
      <StyledMultipleSelectionDropdown ref={this.nodeRef} className="dropDownContainer" displayString={displayString} indicator={this.state.selectedIds.length > 0}>
        <NanoFlex className="dropDownWrapper">
          <Manager>
            <Reference>
              {(targetProps) => {
                return (
                  <NanoFlex
                    ref={targetProps.ref}
                    className="inputDropDownWrapper"
                    justifyContent={"flex-start"}
                    alignItems={"flex-start"}
                    onClick={() => {
                      this.setState({ isOpenDropdown: !this.state.isOpenDropdown });
                    }}>
                    <NanoFlex className="infoDropDownWrapper" justifyContent={"flex-start"}>
                      <Type.p>{displayString ? displayString : this.translation.geral.selectAnOption}</Type.p>
                    </NanoFlex>
                    <NanoFlex className="iconDropDownWrapper">{this.state.isOpenDropdown ? <ArrowUp /> : <ArrowDown className="svgMargin" />}</NanoFlex>
                  </NanoFlex>
                );
              }}
            </Reference>
            {this.state.isOpenDropdown && (
              <Popper placement={"bottom"}>
                {({ ref, style, placement, arrowProps }) => (
                  <NanoFlex ref={ref} style={style} data-placement={placement} className="dropDownContentWrapper" flexDirection={"column"} justifyContent={"flex-start"}>
                    <NanoFlex className="inputSearchWrapper">
                      <Input title={null} defaultValue={this.state.term} placeholder={this.translation.geral.search + "..."} onChangeAction={this.onTermChange} />
                      <NanoFlex className="searchIconWrapper">
                        <SearchIcon />
                      </NanoFlex>
                    </NanoFlex>
                    {filteredResults.length == 0 && (
                      <NanoFlex className="noResults">
                        <Type.p>No Results Found</Type.p>
                      </NanoFlex>
                    )}
                    {(!this.props.hideSelectAll || this.props.hideSelectAll === false) && filteredResults.length > 0 && <BlockBox content={this.translation.geral.selectAll} selected={this.isAllSelected(filteredResults)} blockBoxAction={this.onSelectAllClick} />}
                    {filteredResults.map((v, i) => {
                      return (
                        <BlockBox
                          key={`${i}_${v.id}`}
                          content={v.name}
                          selected={this.state.selectedIds ? this.state.selectedIds.includes(v.id) : false}
                          blockBoxAction={() => {
                            this.onOptionClick(v.id);
                          }}
                          delete={this.props.onDeleteClick ? true : false}
                          deleteAction={() => {
                            this.props.onDeleteClick(v.id);
                          }}
                          customContent={
                            this.props.customContent
                              ? () => {
                                  return this.props.customContent(v);
                                }
                              : null
                          }
                        />
                      );
                    })}
                  </NanoFlex>
                )}
              </Popper>
            )}
          </Manager>
        </NanoFlex>
      </StyledMultipleSelectionDropdown>
    );
  }
}

export default MultipleSelectionDropdown;
// --- // Documentation // --- //
/*
import MultipleSelectionDropdown from './../Nano/MultipleSelectionDropdown.js';
<MultipleSelectionDropdown
    options={ [] }
    onChangeSelection={(id) => console.log(id)}
/>
*/
